module.exports = __webpack_public_path__ + "img/hotel12.7aa15a8b.png";